<template>
  <div>
    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="subtitle is-1 is-hidden-mobile">SEGUINOS</h1>
          <h1 class="subtitle is-3 is-hidden-tablet">SEGUINOS</h1>
          <!-- ICONS -->
          <a
            target="_blank"
            href="https://www.facebook.com/mundofotograficoparana/"
            class="is-secundary"
          >
            <b-icon icon="facebook" size="is-large"></b-icon>
          </a>
          <a
            target="_blank"
            href="https://www.instagram.com/mundofotografico.ok/"
            class="is-secundary"
          >
            <b-icon icon="instagram" size="is-large"></b-icon>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
.hero {
  background-image: url("~@/assets/img/productos/subir-fotos.jpg");
  background: linear-gradient(rgba(31, 44, 108, 0.4), rgba(31, 44, 108, 0.4)),
    rgba(0, 0, 0, 0.4) url("~@/assets/img/productos/subir-fotos.jpg") no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
}
.button-redes{
  margin: 0.2rem
}
</style>

<script>
export default {
  name: 'Redes'
}
</script>
